const formatterDefaults = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
};

type NumberFormatterOptions = { locale?: string; options?: Record<string, string> };

export const numberFormatter = (number: number, params?: NumberFormatterOptions) => {
    const { locale = 'cs', options = { ...formatterDefaults } } = params || {};
    return new Intl.NumberFormat(locale, { ...options }).format(number);
};
